import React, { useState, useMemo } from 'react';
import { useDispatch, useIntl, useSelector } from 'umi';
import { Bubble } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon/index';
import GameSelector from '@/pages/datalab/components/GameSelector';
import { checkNullString } from '@/pages/datalab/utils/utils';
import { getLocalText } from '@/pages/home/utils/utils';
import { formatGamePhase } from '@/pages/dashboard/utils/utils';
import defaultLogo from '@/pages/dashboard/assets/img/svg/gameError.svg';
import { useUpdateEffect } from 'ahooks';
import './index.scss';

type ICustomHeaderProps = {
  isNormal: boolean;
  onSet: (args?: ICustomHeaderProps['isNormal']) => void;
};
export default function LeftMenuCustomHeader(
  props: Partial<ICustomHeaderProps>,
) {
  const { isNormal, onSet: onPropsSet, menuWidth } = props;
  const dispatch = useDispatch();
  const { isExpendLeftMenu,refreshIsNormal } = useSelector(
    (state: any) => ({
      isExpendLeftMenu: state?.datalab?.isExpendLeftMenu,
      refreshIsNormal: state?.datalab?.refreshIsNormal,
    }),
  );
  const setExpendFunc =(val?: boolean) => {
    dispatch({
      type: 'datalab/save',
      payload: {
        isExpendLeftMenu: val,
      }
    });};
  // 迁移公共Menu组件时，datalab的isExpendLeftMenu状态基本上被废弃了，在这里强制监听一遍refreshIsNormal，监听外部改变左侧伸拉缩的状态
  // 新增refreshIsNormal原因：Left组件内部以及datalab外部的状态不可控，导致isExpendLeftMenu会有false的情况。如果二次输入为false，effect会认为没有变化，即不会触发更新
  useUpdateEffect(() => {
    onPropsSet?.(!isExpendLeftMenu);
  }, [isExpendLeftMenu,refreshIsNormal]);
  const onSet = (value: any) => {
    setExpendFunc(!value);
    onPropsSet?.(isNormal);
  };
  return (
    <div className='datalabe-leftmenu'>
      <div className="dbl-left-menu-content-box">
        <NavHeader isExpendLeftMenu={isNormal} onSet={onSet} menuWidth={menuWidth} />
      </div>
    </div>
  );
}

const NavHeader = (props: any) => {
  const { isExpendLeftMenu, onSet, menuWidth } = props;
  const { currentGame } = useSelector(state => ({ currentGame: state.datalab.currentGame }));
  const { locale } = useIntl();

  const [visible, setVisible] = useState(false);

  const { gamePhaseList, lastestPhase } = useMemo(() => {
    // 此处需要过滤除了 SL、Gl、CBT 的游戏阶段，最多展示 6 个游戏阶段
    const phaseWhiteList = ['SL', 'GL', 'CBT'];
    const gamePhaseList = currentGame?.game_phase_list
      ?.filter(
        (phase, index) =>
          phaseWhiteList?.includes(phase.phase_type) && index < 6,
      )
      .reverse();
    const lastestPhase = gamePhaseList?.[gamePhaseList?.length - 1];
    return { gamePhaseList, lastestPhase };
  }, [currentGame]);

  return (
    <>
      <div className='navmenu-hd'>
        {isExpendLeftMenu ? (
          <div>
            <div className='navmenu-hd-title'
              style={{
                padding: '16px 20px 8px',
              }}>{locale === 'en-US' ? 'DataLab' : '数据实验室'}</div>
            <div
              className='navmenu-hd-info'
              onClick={() => {
                setVisible(!visible);
              }}
            >
              <img
                className='navmenu-hd-info-img'
                src={checkNullString(currentGame?.cover) ? defaultLogo : currentGame.cover}
                alt=''
              />
              <div className='navmenu-hd-info-title'>
                <div className='wrapper-context'>
                  <div className='wrapper-context-bd'>
                    <Bubble
                      placement='right'
                      className='bubble-box'
                      trigger='hover'
                      dark
                      content={
                        <>
                          <div className='bubble-text'>{getLocalText(locale, currentGame, 'game_name', 'game_cn_name')}</div>
                          {gamePhaseList?.map((gamePhase: any, index: number) => {
                            const badgeClassName = formatGamePhase(gamePhase?.phase_type, 'className');
                            return (
                              <div className={`bubble-flex`} key={index}>
                                <div className={`bubble-tab ${badgeClassName}`}>
                                  {formatGamePhase(gamePhase?.game_phase, 'type')}
                                </div>
                                <div className={`bubble-time ${index === gamePhaseList?.length - 1 ? 'bubble-time-now' : ''}`}>
                                  {gamePhase?.start_date} ~ {gamePhase?.end_date}
                                </div>
                              </div>
                            );
                          })}
                        </>
                      }
                    >
                      {lastestPhase?.phase_type && (
                        <span className={`text-btn ${formatGamePhase(lastestPhase?.phase_type, 'className')}`}>
                          {formatGamePhase(lastestPhase?.phase_type || '', 'type')}
                        </span>
                      )}
                    </Bubble>
                    {getLocalText(locale, currentGame, 'game_name', 'game_cn_name')}
                  </div>
                </div>
              </div>
              <div className='navmenu-hd-info-icon'>
                <SvgIcon type='left-turn-right' />
              </div>
            </div>
          </div>
        ) : (
          <>
            <div
              className='header-width'
              onClick={() => {
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                !isExpendLeftMenu ? onSet(false) : '';
              }}
            >
              <SvgIcon className='header-width-title' type='bottle' />
            </div>
            <div
              className='header-width'
              onClick={() => {
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                !isExpendLeftMenu ? onSet(false) : '';
              }}
            >
              <SvgIcon className='header-width-icon' type='left-turn-right' />
            </div>
          </>
        )}
      </div>

      {visible && (
        <GameSelector
          visible={visible}
          setVisible={setVisible}
          namespace={'datalab'}
          menuWidth={menuWidth}
        />
      )}
    </>
  );
};
